import React from "react";

// Image
import EmptyImage from "../../../images/empty.svg";

// Components
import { Image, Button } from "antd";
const TargetInputCheckerEmpty = () => {
    return (
        <div className="targetinput-checkerempty">
            <Image
                preview={false}
                src={EmptyImage}
                style={{
                    marginBottom: "20px",
                }}
            />
            <label>Your Knowledge Base Is Empty</label>
            <p>
                To create, click the button below, and you'll be redirected to{" "}
                <b>ONE Knowledge</b>.
            </p>
            <Button
                type="primary"
                onClick={() => {
                    window.open(`https://oneknowledge.sqreemtech.com/`);
                }}
                ghost
            >
                Create Topic/Brand
            </Button>
        </div>
    );
};

export default TargetInputCheckerEmpty;
